import React from "react";
import AddressFilter from "components/filters/Filters/AddressFilter";
import KeywordFilter from "components/filters/Filters/KeywordFilter";

const Filters = () => {
  return <>
    <KeywordFilter
      label={RESX.GeneralLabels.Search}
      placeholder={RESX.GeneralLabels.Search}
      title={RESX.GeneralLabels.Search}
    />
    <AddressFilter />
  </>;
};

export default Filters;